import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "../ui/button";
import { IdCard, LogOut, Settings, User } from "lucide-react";
import { Typography } from "../ui/typography";
import { CardPlusIcon } from "@/icons/card-plus-icon";
import { UserInfo } from "@/hooks/use-auth";

function formatMongolianPhone(phone: string): string {
  // Remove non-digit characters
  const cleaned = phone.replace(/\D/g, "");

  // Remove +976 (Mongolia country code) if it exists
  const local = cleaned.startsWith("976") ? cleaned.slice(3) : cleaned;

  // Format only if 8 digits remain
  if (local.length !== 8) return phone;

  return `${local.slice(0, 4)}-${local.slice(4)}`;
}

export const ProfilePopover = ({ signOut, user }: { signOut: () => void, user: UserInfo|null }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          className="sm:px-14 sm:h-full sm:py-5 sm:rounded-[12px] border-primary font-semibold max-sm:rounded-sm"
          variant={"outline"}
        >
          <div className="p-1 bg-gray-100 rounded-full">
            <User color="black" />
          </div>
          {formatMongolianPhone(user?.phoneNumber ?? "")}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80 bg-background">
        <div className="grid gap-2">
          <div>
            <div className="flex gap-2">
              <div className="p-1 bg-gray-100 rounded-full">
                <User color="black" />
              </div>
              <Typography variant={"heading3"} className="text-white">
                {formatMongolianPhone(user?.phoneNumber ?? "")}
              </Typography>
            </div>
            <Typography className="pl-10">Profile</Typography>
          </div>
          {/* <div className="border-primary flex flex-col gap-5 border rounded-2xl p-2">
            <div className="flex gap-1 text-white ">
              <IdCard />
              <Typography className="text-white font-semibold">
                Membership
              </Typography>
            </div>
            <Typography className="text-white font-semibold text-center">
              2025/12/23 дуусах болно
            </Typography>
            <Button className="text-white">
              <CardPlusIcon /> Сунгах
            </Button>
          </div>
          <Button variant={"outline"} className="text-white">
            <Settings /> Тохиргоо
          </Button> */}
          <Button variant={"outline"} className="text-white" onClick={signOut}>
            <LogOut /> Систем гарах
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
